import React from 'react';
import classnames from 'classnames';
import ProfileImage from '@fiverr-private/profile_image';
import { useBreakpoints } from '@fiverr-private/hooks';
import { getContext } from '@fiverr-private/fiverr_context';
import { FederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { calcIconSize } from './utils';
import {
    roleVideoAvatarClass,
    avatarClass,
    introVideoButtonLgClass,
    introVideoButtonMdClass,
    introVideoButtonSmClass,
} from './styles.ve.css';

export const VideoAvatar = () => {
    const { profileImageUrl, username, sellerId, isPro, introVideo } = useSellerData(selectSellerSlice);
    const { isMobile } = getContext();
    const { lg: isLG, md: isMD } = useBreakpoints();
    const introVideoUrl = introVideo?.url;
    const userProps = {
        user_id: sellerId,
        username,
        has_profile_photo: profileImageUrl !== null,
        profile_photo: profileImageUrl,
        achievement: 0,
        is_pro: isPro,
    };

    const additionalProfileImageProps = {
        introVideo: introVideoUrl,
        mode: ProfileImage?.MODES?.VIDEO_INTENT,
        introVideoPlayButtonIconSize: calcIconSize({ isLG, isMobile, isMD }),
        introVideoPlayButtonClassName: classnames({
            [introVideoButtonSmClass]: !isMD,
            [introVideoButtonMdClass]: (!isLG && isMD) || (isMobile && isLG),
            [introVideoButtonLgClass]: !isMobile && isLG,
        }),
    };

    return (
        <div className={roleVideoAvatarClass}>
            <ProfileImage
                className={avatarClass}
                profileImageSize={120}
                user={userProps}
                {...additionalProfileImageProps}
            />
        </div>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        sellerId: seller.user.id,
        username: seller.user.name,
        profileImageUrl: seller.user.profileImageUrl,
        introVideo: seller.introVideo,
        isPro: seller.isPro,
    };
}
